import { get } from 'lodash'
import { required, requiredPhone, phone, email } from 'utils/validation'
import { DELIVERY_TYPES } from 'constants/enums'

const validate = (values, props) => {
  let errors = {}

  errors = {
    parentFirstName: required(get(values, 'parentFirstName')),
    parentLastName: required(get(values, 'parentLastName')),
    parentPhone:
      requiredPhone(get(values, 'parentPhone')) ||
      phone(get(values, 'parentPhone')),
    parentRelationship: required(get(values, 'parentRelationship')),
    consentDeliveryType: {
      value: required(get(values, 'consentDeliveryType.value'))
    }
  }

  if (
    get(props, 'parentEmailRequired') ||
    get(values, 'consentDeliveryType.value') ===
      DELIVERY_TYPES.ELECTRONICALLY.value
  ) {
    errors.parentEmail =
      required(get(values, 'parentEmail')) || email(get(values, 'parentEmail'))
  } else {
    errors.parentEmail = email(get(values, 'parentEmail'))
  }

  if (get(values, 'parentEmail')) {
    errors.parentEmailCheck = required(get(values, 'parentEmailCheck'))
  }

  if (
    get(values, 'parentEmail') &&
    get(values, 'parentEmailCheck') &&
    get(values, 'parentEmail') !== get(values, 'parentEmailCheck')
  ) {
    errors = {
      ...errors,
      parentEmailCheck: {
        text: "Emails don't match",
        intlKey: 'errors.emails_dont_match',
        values: {}
      }
    }
  }

  return errors
}

export default validate
